import React, { useContext } from 'react';
import { injectIntl } from 'react-intl';
import { useTheme } from 'ThemeContext';
import { AppSettingsContext } from 'AppSettingsContext';
import { Wrapper, Container, Text } from './FooterCopyright.style';

function FooterCopyright({ intl, owner, period, producer, producerHref }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);
  return (
    <>
      {owner || period || producer ? (
        <Wrapper theme={theme.footerCopyright.wrapper}>
          <Container
            widerTheme={appSettings.theme === 6 ? String(true) : undefined}
            narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
          >
            <Text theme={theme.footerCopyright.text}>
              Copyright {owner} {period}
              {producer ? (
                <>
                  {` | ${intl.formatMessage({
                    id: 'FOOTER_COPYRIGHT.PRODUCER'
                  })}: `}
                  {producerHref ? (
                    <a
                      href={producerHref}
                      target='_blank'
                      rel='noopener noreferrer nofollow'
                    >
                      {producer}
                    </a>
                  ) : (
                    producer
                  )}
                </>
              ) : (
                ''
              )}
            </Text>
          </Container>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
}

export default injectIntl(FooterCopyright);
